// Small calculator embedded in articles: compares two instruments for one year, or shows a real return over time.

function number(root, field, fallback = 0) {
    const input = root.querySelector(`[data-field="${field}"]`);
    const value = input ? parseFloat(input.value) : NaN;
    return Number.isFinite(value) && value >= 0 ? value : fallback;
}

function setText(root, name, text) {
    const element = root.querySelector(`[data-output="${name}"]`);
    if (element) {
        element.textContent = text;
    }
}

function setWidth(root, name, value, max) {
    const element = root.querySelector(`[data-output="${name}"]`);
    if (element) {
        element.style.width = `${max > 0 ? (value / max) * 100 : 0}%`;
        element.style.display = value > 0 ? 'block' : 'none';
    }
}

function instrument(amount, rate, taxPercent, allowance, stampPercent) {
    const gross = amount * rate / 100;
    const tax = Math.max(0, gross - allowance) * taxPercent / 100 + amount * stampPercent / 100;
    return { gross, tax, net: gross - tax };
}

function renderCompare(root, money) {
    const data = root.dataset;
    const amount = number(root, 'amount');
    const allowance = parseFloat(data.allowance) || 0;
    const stamp = parseFloat(data.stamp) || 0;
    const a = instrument(amount, number(root, 'rateA'), parseFloat(data.taxA) || 0, allowance, stamp);
    const b = instrument(amount, number(root, 'rateB'), parseFloat(data.taxB) || 0, allowance, stamp);
    const max = Math.max(Math.max(a.net, 0) + a.tax, Math.max(b.net, 0) + b.tax);

    [['a', a], ['b', b]].forEach(([key, item]) => {
        setText(root, `values-${key}`, `${data.net} ${money(item.net)} · ${data.tax} ${money(item.tax)}`);
        setWidth(root, `net-${key}`, Math.max(item.net, 0), max);
        setWidth(root, `tax-${key}`, item.tax, max);
    });

    const difference = Math.abs(a.net - b.net);
    if (difference < 0.5) {
        setText(root, 'summary', data.equal);
    } else {
        const winner = a.net > b.net ? data.labelA : data.labelB;
        setText(root, 'summary', data.more.replace('{a}', winner).replace('{b}', money(difference)));
    }
}

function renderReal(root, money, percent) {
    const amount = number(root, 'amount');
    const net = number(root, 'rateA') * (1 - Math.min(number(root, 'tax'), 100) / 100) / 100;
    const inflation = number(root, 'inflation') / 100;
    const years = Math.min(Math.max(Math.round(number(root, 'years', 1)), 1), 50);
    const balance = amount * Math.pow(1 + net, years);
    const buying = balance / Math.pow(1 + inflation, years);
    const real = ((1 + net) / (1 + inflation) - 1) * 100;

    setText(root, 'balance', money(balance));
    setText(root, 'buying', money(buying));
    setText(root, 'real', percent(real));
    setText(root, 'summary', root.dataset.more.replace('{a}', percent(real)).replace('{b}', money(buying - amount)));
}

function init(root) {
    const data = root.dataset;
    const integer = new Intl.NumberFormat(data.culture, { maximumFractionDigits: 0 });
    const decimal = new Intl.NumberFormat(data.culture, { maximumFractionDigits: 2 });
    const money = value => `${integer.format(value)}${data.suffix || ''}`;
    const percent = value => `${decimal.format(value)}%`;
    const render = () => (data.mode === 'real' ? renderReal(root, money, percent) : renderCompare(root, money));

    let reported = false;
    root.addEventListener('input', () => {
        render();
        if (!reported) {
            reported = true;
            document.dispatchEvent(new CustomEvent('monsave:guide-calc-used', { detail: { mode: data.mode } }));
        }
    });
    render();
}

function start() {
    document.querySelectorAll('[data-article-calc]').forEach(init);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
} else {
    start();
}
